import { render, staticRenderFns } from "./NewMessageTemplate.vue?vue&type=template&id=9148f588&"
import script from "./NewMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./NewMessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports